import { Injectable } from '@angular/core';

@Injectable()
export class AutoCompleteService {

    createOptionOnSelect2(selectId: string, optionToSet: any) {
        var option: any = document.createElement("OPTION");
        option.setAttribute("value", optionToSet.id);
        var text = document.createTextNode(optionToSet.text);
        option.appendChild(text);
        var element: any = document.getElementById(selectId);
        if (element) {
            element.appendChild(option);
        }
        $("#" + selectId + " select").append(option);
    }

    setValueOnSelect2(value:any, selectedId: any) {
        var select: any = $("#" + selectedId + " select");
        select.val(value).trigger("change");
    }

    setNewTagInList(state: any) {
        var text: string;
        if(state.text === "") {
            text = "Criar novo";
        } else {
            text = "<b>\""+state.text+"\"</b> (criar novo)";
        }
        return $('<span class="last_item_select2"> ' + text + '</span>');
    }

    setNoCreateNew(text: string) {
        return $('<span class="last_item_select2 not_link">' + text + '</span>');
    }

    getTextSelect2(obj: any, att: string) {
        var text: string = '';

        if (obj) {
            text = obj.text;
            if (obj[att]) {
                text = obj[att];
            }
        }

        return text;
    }

    //storage
    setSessionStorage(item: any, module: string) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem('autocomplete-new-' + module, object);
    }

    getSessionStorage(module: string) {
        var item: string = sessionStorage.getItem("autocomplete-new-" + module);
        return JSON.parse(item);
    }

    clearSessionStorage(module: string) {
        sessionStorage.removeItem("autocomplete-new-" + module);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/components/autocomplete/autocomplete.service.ts
 **/